import LeadHeader from "@/modules/lead-page/new/components/header/lead-header";
import LeadHeaderSkeleton from "@/modules/lead-page/new/components/header/lead-header-skeleton";

export default function LeadStatus({ isLoading }: { isLoading: boolean }) {
  if (isLoading) {
    return <LeadHeaderSkeleton />;
  }

  return <LeadHeader />;
}
